
/**
 * Validates a Djibouti phone number
 */
export const validatePhoneNumber = (phoneNumber: string): boolean => {
  if (!phoneNumber) {
    console.log("Phone validation failed: number is empty");
    return false;
  }
  
  // Check if the phone number has exactly 8 digits
  const phoneRegex = /^\d{8}$/;
  const isValid = phoneRegex.test(phoneNumber);
  
  console.log(`Phone validation for "${phoneNumber}": ${isValid ? 'valid' : 'invalid'}`);
  return isValid;
};
